import { CircularProgress, CircularProgressProps } from '@mui/material';

const CircularProgressComponent: React.FC<CircularProgressProps> = props => {
  return <CircularProgress {...props} />;
};

export default CircularProgressComponent;
